import { QueryClient } from '@tanstack/react-query';
import {
  QUERY_GC_TIME,
  QUERY_REFETCH_ON_WINDOW_FOCUS,
  QUERY_RETRY_COUNT,
  QUERY_STALE_TIME,
} from './config.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME,
      gcTime: QUERY_GC_TIME,
      retry: QUERY_RETRY_COUNT,
      refetchOnWindowFocus: QUERY_REFETCH_ON_WINDOW_FOCUS,
    },
  },
});

export default queryClient;
